import { render, staticRenderFns } from "./zCpfCnpj.vue?vue&type=template&id=f4b5cfa2&scoped=true&"
import script from "./zCpfCnpj.vue?vue&type=script&lang=js&"
export * from "./zCpfCnpj.vue?vue&type=script&lang=js&"
import style0 from "./zCpfCnpj.vue?vue&type=style&index=0&id=f4b5cfa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b5cfa2",
  null
  
)

export default component.exports